import { Query } from '@apollo/client/react/components';
import { AppContext } from '@nile/components';
import { GET_TICKET_CONVERSATIONS } from '@nile/graphql';
import { ConversationBubble } from '@nile/mangifera/src/Components/Chat';
import { ActionContainer } from '@nile/mangifera/src/Containers/ChatContainers';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import React, { useCallback, useContext, useState } from 'react';
import { ChatFeed } from 'react-bell-chat';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';

const StyledConversation = styled.div`
  height: 91vh;
  background: #ecf0f1;
  border-bottom: 1px solid #e7e7e7;

  .Polaris-Card {
    margin: 20px;
  }
`;

function ConversionContainer(props) {
  const [editor, setEditor] = useState({ content: '' });
  const context = useContext(TicketContext);
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const { ticket } = props;

  const onMessageSubmit = useCallback((message, e) => {
    const conversation = {
      ticketId: ticket.ticketId,
      content: message,
      toUsers: [{ userId: user.userId }]
    };
    context.saveTicketConversation({
      variables: conversation,
      input: conversation
    });
  }, []);

  return (
    <StyledConversation>
      {
        <Query
          query={GET_TICKET_CONVERSATIONS}
          variables={{ ticketId: ticket.ticketId }}
        >
          {({ loading, error, data }) => {
            if (loading) {
              return <div>loading</div>;
            }

            if (error) {
              return <div>error</div>;
            }

            const authors = [];
            const conversations = data.getTicketConversations.map((note) => {
              authors.push({
                name: note.user.firstName + '  ' + note.user.lastName
              });
              return {
                message: note.content,
                id: note.noteId,
                isSend: true,
                authorId: note.user.userId,
                user: note.user
              };
            });

            return (
              <ChatFeed
                yourAuthorId={0}
                customChatBubble={ConversationBubble}
                messages={conversations}
                authors={authors}
                yourAuthorId={user.userId}
              />
            );
          }}
        </Query>
      }

      <ActionContainer
        template={editor}
        ReadOnly={true}
        onMessageSubmit={onMessageSubmit}
        module="TICKET_CONVERSATION"
        details={{
          operation: 'CREATE',
          ticketId: ticket.ticketId
        }}
      />
    </StyledConversation>
  );
}

export default ConversionContainer;
